// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import chevronRight from "./assets/chevron-right.svg";
var CARE_COMMON_ASSETS_MAP = {
  CHEVRON_RIGHT: chevronRight
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CARE_COMMON_ASSETS_MAP);
};

// src/types/care-common.types.ts
var CARE_COMMON_ASSET_KEYS = /* @__PURE__ */ ((CARE_COMMON_ASSET_KEYS2) => {
  CARE_COMMON_ASSET_KEYS2["CHEVRON_RIGHT"] = "CHEVRON_RIGHT";
  return CARE_COMMON_ASSET_KEYS2;
})(CARE_COMMON_ASSET_KEYS || {});

// src/components/care-page-wrapper/care-page-wrapper.component.tsx
import * as React from "react";
import { Box, Flex, HeadingOne } from "@leagueplatform/genesis-commons";
import { Link } from "@leagueplatform/routing";
import {
  BackButtonArrow,
  PageHeaderBackground
} from "@leagueplatform/web-common-components";
function CarePageWrapper({
  backButtonPath,
  backButtonOnClick,
  children,
  title
}) {
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      maxWidth: "1272px",
      width: "100%",
      padding: { _: "oneAndHalf", phone: "two" },
      marginX: "auto",
      justifyContent: "center"
    },
    title && /* @__PURE__ */ React.createElement(PageHeaderBackground, null),
    /* @__PURE__ */ React.createElement(
      Flex,
      {
        flexDirection: { _: "column", phone: "row" },
        width: "100%",
        alignItems: "flex-start"
      },
      (backButtonPath || backButtonOnClick) && /* @__PURE__ */ React.createElement(
        BackButtonArrow,
        {
          as: Link,
          to: backButtonPath,
          marginTop: "threeQuarters",
          marginLeft: "none",
          marginRight: "two",
          onClick: backButtonOnClick
        }
      ),
      /* @__PURE__ */ React.createElement(Box, { width: "100%" }, title && /* @__PURE__ */ React.createElement(
        HeadingOne,
        {
          marginTop: "half",
          marginBottom: "five",
          fontSize: { _: "heading2", phone: "heading1" }
        },
        title
      ), children)
    )
  );
}

// src/utils/is-tenant.ts
import { getInitializationConfig } from "@leagueplatform/core";
var getCurrentTenant = () => {
  var _a;
  return (_a = getInitializationConfig()) == null ? void 0 : _a.tenantId;
};
var HighmarkTenantsList = [
  "highmark-beneficity" /* BENEFICITY */,
  "highmark-iel" /* MY_HIGHMARK */,
  "hm-allmyhealth" /* ALL_MY_HEALTH */
];
var isHighmark = () => HighmarkTenantsList.some(
  (highmarkTenant) => highmarkTenant === getCurrentTenant()
);

// src/index.tsx
initModule();
export {
  CARE_COMMON_ASSET_KEYS,
  CarePageWrapper,
  isHighmark
};
//# sourceMappingURL=index.js.map